import { motion } from "framer-motion";
import { Search, PenLine, Wrench, PackageCheck } from "lucide-react";

const steps = [
  { n: "01", icon: Search, title: "Understand Requirements", body: "Discovery workshops, technical scoping and stakeholder alignment." },
  { n: "02", icon: PenLine, title: "Plan the Right Solution", body: "Costed proposal, timelines, vendor mix and quality gates." },
  { n: "03", icon: Wrench, title: "Source or Execute", body: "Structured sourcing or on-site execution with weekly reporting." },
  { n: "04", icon: PackageCheck, title: "Deliver with Quality", body: "Inspection, handover documentation and post-delivery support." },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[var(--nv-paper)] text-[var(--nv-navy)] py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6">
            <div className="overline text-[var(--nv-gold)] flex items-center gap-3">
              <span className="inline-block w-6 h-px bg-[var(--nv-gold)]" />
              <span>Our Process</span>
            </div>
            <h2 className="mt-6 display text-5xl md:text-7xl" data-testid="process-heading">
              A method, not a <span className="italic text-[var(--nv-gold)]">promise.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-[15px] leading-relaxed text-[var(--nv-navy)]/70">
            Four disciplined stages, each with clear deliverables and sign-offs.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="hidden md:block absolute top-8 left-0 right-0 h-px bg-[var(--nv-line)]" aria-hidden />
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1], delay: i * 0.1 }}
                className="relative pt-16"
                data-testid={`process-step-${s.n}`}
              >
                <div className="absolute top-0 left-0 flex items-center justify-center w-16 h-16 rounded-full border border-[var(--nv-navy)] bg-[var(--nv-paper)]">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="pt-2">
                  <span className="font-mono text-xs tracking-[0.24em] text-[var(--nv-gold)]">{s.n} / 04</span>
                  <h3 className="mt-3 font-serif text-2xl md:text-3xl tracking-tight leading-[1.1]">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-[var(--nv-navy)]/70">{s.body}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
